import Http, {HttpConfig} from '../model/Http'
import Vue from 'vue'

export default class HttpService{
	constructor(config = new HttpConfig()) {
		this.axios = new Http(config)
	}
	
	async get(url, params, config){
		return this.axios.getInstance().get(url, {params}, config)
	}
	
	async post(url, params, config){
		return this.axios.getInstance().post(url, params, config)
	}
	
	setVueInstance(vueInstance){
		vueInstance && (vueInstance instanceof Vue) && this.axios.setVueInstance(vueInstance)
	}
}